module.exports = __webpack_public_path__ + "static/media/logo-Usame-web-color.6b6451fe.png";